import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { GaDetailsComponent } from './ga-details/ga-details.component';

@Component({
  selector: 'app-consent',
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogContent, MatIconModule],
  templateUrl: './consent.component.html',
  styleUrl: './consent.component.scss',
})
export class ConsentComponent {
  readonly privacyPolicyUrl = $localize`:@@consent.link.privacyPolicy:https://www.business-one.cloud/en/privacy`;
  readonly imprintUrl = $localize`:@@consent.link.imprint:https://www.business-one.cloud/en/imprint`;
  readonly accepted: boolean | null;

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: { accepted: boolean | null }
  ) {
    this.accepted = data.accepted;
  }

  openDetails(): void {
    this.dialog.open(GaDetailsComponent, { panelClass: 'gadetails-dialog' });
  }
}
